import { connect } from 'react-redux'

import GestionCompteTiers from '../../../pages/settings/CompteTiers'
import {
  resetSuccessAction,
  fetchCompteTiers,
  onSearch,
  pageChanged,
  pageLimitChanged,
  removeError,
  resetCompteTiersConfig,
} from '../../../redux/compteTiers/actions'

import {
  getCompteTiers,
  getCompteTiersCount,
  getCompteTiersListIsLoading,
  getErrorMessage,
  getIsErrorFetch,
  getIsSuccessRefresh,
  getSuccess,
} from '../../../redux/compteTiers/selectors'

const mapStateToProps = (state) => ({
  isLoadingCompteTiersList: getCompteTiersListIsLoading(state),
  compteTiers: getCompteTiers(state),
  compteTiersCount: getCompteTiersCount(state),
  errorMessage: getErrorMessage(state),
  isErrorFetch: getIsErrorFetch(state),
  isSuccessRefresh: getIsSuccessRefresh(state),
  success: getSuccess(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(fetchCompteTiers())
  },
  pageLimitChanged: (limit) => {
    dispatch(pageLimitChanged(limit))
    dispatch(fetchCompteTiers())
  },
  pageChanged: (offset) => {
    dispatch(pageChanged(offset))
    dispatch(fetchCompteTiers())
  },
  removeError: () => dispatch(removeError()),
  resetSuccessAction: () => dispatch(resetSuccessAction()),
  onCloseReset: () => dispatch(resetCompteTiersConfig()),

  searchData: (search) => {
    dispatch(onSearch(search))
    dispatch(fetchCompteTiers())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(GestionCompteTiers)
